export default __webpack_public_path__ + "static/media/placeholder_business04-es-mobile.5dc76060.png";